import { fromLonLat } from 'ol/proj';

export const startingPoint = [2.5, 8];
export const defaultMapProjection = 'EPSG:3857';
export const center = fromLonLat(startingPoint, defaultMapProjection);
export const initialZoom = 6;
export const minZoom = 1;
export const maxZoom = 25;
